<template>
  <div v-if="category">
    <h1>Category</h1>
    <v-btn :to="{ name: 'categories' }">
      <v-icon>chevron_left</v-icon>Categories
    </v-btn>
    <v-form ref="formCategory" v-model="valid" lazy-validation>
      <v-text-field label="Id" v-model="category.id" outline readonly />
      <v-text-field
        label="Code"
        v-model="category.code"
        :rules="valueRules"
        outline
      />
      <v-text-field
        label="Name"
        v-model="category.name"
        :rules="valueRules"
        outline
      />
      <v-text-field
        label="Short name"
        v-model="category.shortname"
        :rules="valueRules"
        outline
      />
      <v-btn @click="saveCategory"> <v-icon>save</v-icon>Save </v-btn>
    </v-form>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Category",
  metaInfo() {
    return {
      title: "Category",
      titleTemplate: "%s - File - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  data() {
    return {
      category: null,
      valid: false,
      valueRules: [(v) => !!v || "Value is required"]
    };
  },
  methods: {
    async fetchCategory() {
      const response = await nbmlaw.get(
        `/cors/admin/file/categories/${this.$route.params.id}`
      );
      // console.log(response.data);
      this.category = response.data;
    },
    saveCategory() {
      if (this.$refs.formCategory.validate()) {
        if (this.$route.params.id) {
          this.updateCategory();
        } else {
          this.createCategory();
        }
      }
    },
    async createCategory() {
      await nbmlaw.post(`/cors/admin/file/categories`, this.category);
      this.$router.push({ name: "categories" });
    },
    async updateCategory() {
      await nbmlaw.put(
        `/cors/admin/file/categories/${this.$route.params.id}`,
        this.category
      );
      this.$router.push({ name: "categories" });
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        if (this.$route.params.id) {
          this.fetchCategory();
        } else {
          this.category = {};
        }
      }
    }
  }
};
</script>